import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { toDate, validateDate } from "../utils/date";
import { isArray, isDate, isObject, toArray } from "../utils/type";
export var getDefaultRangeState = function getDefaultRangeState() {
  return {
    from: null,
    to: null,
    enteredTo: null
  };
};
export var parseRange = function parseRange(val) {
  if (!val) return {};

  var _ref = isArray(val) ? val : val.split(' '),
      _ref2 = _slicedToArray(_ref, 3),
      from = _ref2[0],
      delimiter = _ref2[1],
      to = _ref2[2];

  var result = {
    from: undefined,
    to: undefined,
    enteredTo: undefined,
    delimiter: delimiter
  };

  if (validateDate(from)) {
    result.from = toDate(from);
  }

  var rangeEnd;

  if (to && validateDate(to)) {
    rangeEnd = to;
  } else if (delimiter && validateDate(delimiter)) {
    rangeEnd = delimiter;
  }

  if (rangeEnd) {
    var dateTo = toDate(rangeEnd);
    var timeOfDateTo = dateTo.getTime();

    if (!result.from || result.from.getTime() <= timeOfDateTo) {
      result.to = dateTo;
      result.enteredTo = new Date(timeOfDateTo);
      result.enteredTo.setHours(12);
    }
  }

  return result;
};
export var parseValue = function parseValue(value, multiple) {
  if (!value) return undefined;

  if (multiple) {
    return toArray(value).length > 0 ? toArray(value).map(function (item) {
      return toDate(item);
    }) : [];
  }

  return toDate(value);
};
export var initializeYears = function initializeYears() {
  var from = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1920;
  var to = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2050;
  var years = [];

  for (var i = to; i >= from; i -= 1) {
    years.push({
      label: "".concat(i),
      value: i
    });
  }

  return years;
};
export var isMinDateGreatThanMaxOne = function isMinDateGreatThanMaxOne(val) {
  var result = false;

  if (isArray(val)) {
    val.forEach(function (item) {
      if (!isDate(item) && isObject(item) && isDate(item.before) && isDate(item.after) && item.before.getTime() > item.after.getTime()) {
        result = true;
      }
    });
  }

  return result;
};